import React from 'react';
export var DefaultLayout = function (_a) {
    var header = _a.header, footer = _a.footer, children = _a.children;
    return (React.createElement("div", { className: "flex flex-col h-full" },
        header,
        React.createElement("main", { className: "container xl:max-w-[912px] grow my-4" },
            React.createElement("div", { className: 'p-2' }, children)),
        footer));
};
